import { LEReportData, LEStandardReportData, ReportTreeNode } from '../types';
import { flattenTree, updateScoreData } from './CommonReportHelper';

export const flattenStandardTree = (standardTree: ReportTreeNode) => {
  return flattenTree(standardTree);
};

export const fillStandardScoreData = (standardScoreData: LEReportData, standardReportData: LEStandardReportData, standardTree: ReportTreeNode) => {
    const recursiveFillItemToNodes = (item: string, userId: string, node: ReportTreeNode) => {
        const internalItem = item;
        const itemData = standardReportData?.[userId]?.[internalItem];
        if(!itemData) {
            return;
        }

        const standardScoreObj = Object.values(itemData)[0];
        const itemStandards = Object.keys(itemData);

        if(!standardScoreObj) {
            return;
        }
        const innerRec = (node: ReportTreeNode) => {
            let found = false;
            if(itemStandards.includes(`${node.id}`)) {                
                found = true;
                updateScoreData(standardScoreData, userId, node.id, standardScoreObj);
                return found;
            }
            node.subNodes.forEach((subNode) => {
                found = found || innerRec(subNode);
            });
            if(!found) {
                return found;
            }
            updateScoreData(standardScoreData, userId, node.id, standardScoreObj);
            return found;
        };      
        innerRec(node);
        
    };
    const userIds = Object.keys(standardReportData);
    userIds.forEach((userId) => {
        Object.keys(standardReportData?.[userId]).forEach((item) => {
            recursiveFillItemToNodes(item, userId, standardTree);
        });
    });
    return standardScoreData;
};